import React, { Fragment, useMemo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";

// import Loader from "../Loader/Loader.jsx";
import { useStore } from "../../hook-store/store.js";

// import { ollamaMcpPdfToText } from "../../utils/ollama/pdf-file.js";
// import { marks } from "../../../utils/marks.jsx";
import "./PdfToTextSelectPage.css";


export default function PdfToTextSelectPage(props) {
    const { 
      // inputPdfFile,
      // setPdfTextData,
      pdfTextData,
      showSelectPage,
      setShowSelectePage,
      selectedPageIdxs,
      setSelectedPageIdxs,
      createCombineTextHandler,
    } = props;

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    // const { 
    // } = store.mlSpeechStore;


    const selecteTextPageHandler = (idx) => {

      const prePages = selectedPageIdxs;
      console.log(prePages)

      const isInList = prePages.find(ele => {
        return ele === idx;
      })

      if (!isInList) {
        const addedList = prePages.concat([idx]);
        console.log(addedList);
        setSelectedPageIdxs(addedList);
      }
    };

    const deletePageHandler = (idx) => {
      const deletedList = selectedPageIdxs.filter(ele => {
        return ele !== idx;
      });

      setSelectedPageIdxs(deletedList);
    };

    const sortSelectedPagesHandler = (selectedPageIdxs) => {
      const sortedList = _.sortBy(selectedPageIdxs);
      setSelectedPageIdxs(sortedList);
    };

    let pdfToTextSelectPageBody;

    if (pdfTextData && pdfTextData.length > 1) {
      pdfToTextSelectPageBody = (
        <div className="pdfToTextResultSelectPage">
          {/* {pdfTextData && pdfTextData.length > 1 && (
            <div>
              <div>
                <span
                  onClick={() => {
                    setShowSelectePage(!showSelectPage);
                  }}
                >
                  display-select-page
                </span>
              </div>
            </div>
          )} */}

          {pdfTextData && pdfTextData.length > 1 && showSelectPage && (
            <div>
                <div>
                  {/* <div>result-page-num: {pdfTextData.length}</div> */}
                  
                  <div className="pdfToTextResultSelectPageSection">
                    <div>
                      {t('pdfToText13', 'Select page')}
                    </div>
                    <ul className="pdfToTextResultSelectPagePages"
                      // style={{display: "flex", flexWrap: "wrap", gap:"0.5rem"}}
                    >
                      {pdfTextData.map((element, index) => {
                        // console.log(index, selectedPageIdxs)
                        const isInSelectedPageIdx = selectedPageIdxs.findIndex(idx => {
                          return idx === index;
                        })

                        let buttonStyle = null;

                        if (isInSelectedPageIdx > -1) {
                          buttonStyle = {
                            color: "gray", 
                          };
                        }

                        // console.log(isInSelectedPageIdx, index, selectedPageIdxs)
                        
                        return (
                          <li key={index}>
                            <div className="pdfToTextResultSelectPagePageButton"
                              style={buttonStyle}
                            >
                              <span
                                onClick={() => {
                                  selecteTextPageHandler(index);
                                }}
                              >
                                {t('pdfToText16', 'page')}
                                {' '}{index+1}
                              </span>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
  
                  <div className="pdfToTextResultSelectPageSection">
                    <div>{t('pdfToText17', 'Selected pages')}</div>
                    <ul>
                      {selectedPageIdxs.map((element) => {
                        return (
                          <li key={element}>
                            <div className="pdfToTextResultSelectedPageRow">
                              <strong>
                                {t('pdfToText16', 'page')} 
                                {' '}{element+1}
                              </strong>
                              <button className="btnBase"
                                onClick={() => {
                                  deletePageHandler(element)
                                }}
                              >
                                {t('pdfToText18', 'Delete')}
                              </button>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  {selectedPageIdxs.length > 0 && (
                    <div>
                      <div className="pdfToTextResultSelectPageSection">
                        <button className="btnBase"
                          onClick={() => {
                            sortSelectedPagesHandler(selectedPageIdxs);
                          }}
                        >
                          {t('pdfToText19', 'Sort selected pages')}
                        </button>
                        <span>(3, 2, 7, 5 {`-->`} 2, 3, 5, 7)</span>
                      </div>

                      <button className="btnBase"
                        onClick={() => {
                          createCombineTextHandler(pdfTextData, selectedPageIdxs);
                        }}
                      >
                        {t('pdfToText20', 'Create text file from selected pages')}
                      </button>
                    </div>
                  )}
                </div>
          
            </div>
          )}

        </div>
      )
    }

    return (
        <Fragment>
          <div>{pdfToTextSelectPageBody}</div>
        </Fragment>
    );
  };
